import { gql } from '@apollo/client';

export const GET_FUNERAL_SERVICE_BY_ID = gql`
  query GetFuneralServiceById($id: ID!) {
    defunto(id: $id) {
      objectId
      nome
      cognome
      sesso
      data_morte
      cimitero
      forno
      createdAt
      company_pointer {
        objectId
        alias
        cap_fatturazione
        citta_fatturazione
        codice_destinatario
        codice_fiscale
        colore_principale
        colore_secondario
        colore_testo
        colore_testo_intestazione
        cover_image {
          url
          name
        }
        email_fatturazione
        enabled
        fatturazione_elettronica
        iban
        indirizzo_fatturazione
        intestatario_banca
        nome
        nome_banca
        partita_iva
        pec
        provincia_fatturazione
        ragione_sociale
        regime_fiscale
        sito
        slug
        logo {
          url
          name
        }
        logo_completo {
          url
          name
        }
        logo_sito {
          url
          name
        }
        timbro {
          url
          name
        }
      }
      office_pointer {
        objectId
        cap
        cellulare1
        cellulare2
        citta
        email
        enabled
        frazione
        indirizzo
        name
        nascondi
        pec
        provincia
        telefono1
        telefono2
        logo {
          url
          name
        }
        logo_completo {
          url
          name
        }
        logo_sito {
          url
          name
        }
        funeral_home_pointer {
          objectId
          name
          alias
        }
        company_pointer {
          objectId
          alias
          cap_fatturazione
          citta_fatturazione
          codice_destinatario
          codice_fiscale
          colore_principale
          colore_secondario
          colore_testo
          colore_testo_intestazione
          cover_image {
            url
            name
          }
          email_fatturazione
          enabled
          fatturazione_elettronica
          iban
          indirizzo_fatturazione
          intestatario_banca
          nome
          nome_banca
          partita_iva
          pec
          provincia_fatturazione
          ragione_sociale
          regime_fiscale
          sito
          slug
          logo {
            url
            name
          }
          logo_completo {
            url
            name
          }
          logo_sito {
            url
            name
          }
          timbro {
            url
            name
          }
        }
      }
    }
  }
`;

export const COUNT_FUNERAL_SERVICES = gql`
  query CountFuneralServices {
    defuntos {
      count
    }
  }
`;

export const FIND_FUNERAL_SERVICES = gql`
  query FindFuneralServices(
    $limit: Int!
    $after: String
    $where: DefuntoWhereInput!
  ) {
    defuntos(
      first: $limit
      order: data_morte_DESC
      where: $where
      after: $after
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      count
      edges {
        node {
          id
          cimitero
          forno
          objectId
          nome
          cognome
          data_morte
          sesso
          createdAt
          company_pointer {
            objectId
            alias
            cap_fatturazione
            citta_fatturazione
            codice_destinatario
            codice_fiscale
            colore_principale
            colore_secondario
            colore_testo
            colore_testo_intestazione
            cover_image {
              url
              name
            }
            email_fatturazione
            enabled
            fatturazione_elettronica
            iban
            indirizzo_fatturazione
            intestatario_banca
            nome
            nome_banca
            partita_iva
            pec
            provincia_fatturazione
            ragione_sociale
            regime_fiscale
            sito
            slug
            logo {
              url
              name
            }
            logo_completo {
              url
              name
            }
            logo_sito {
              url
              name
            }
            timbro {
              url
              name
            }
          }
          office_pointer {
            objectId
            cap
            cellulare1
            cellulare2
            citta
            email
            enabled
            frazione
            indirizzo
            name
            nascondi
            pec
            provincia
            telefono1
            telefono2
            logo {
              url
              name
            }
            logo_completo {
              url
              name
            }
            logo_sito {
              url
              name
            }
            funeral_home_pointer {
              objectId
              name
              alias
            }
            company_pointer {
              objectId
              alias
              cap_fatturazione
              citta_fatturazione
              codice_destinatario
              codice_fiscale
              colore_principale
              colore_secondario
              colore_testo
              colore_testo_intestazione
              cover_image {
                url
                name
              }
              email_fatturazione
              enabled
              fatturazione_elettronica
              iban
              indirizzo_fatturazione
              intestatario_banca
              nome
              nome_banca
              partita_iva
              pec
              provincia_fatturazione
              ragione_sociale
              regime_fiscale
              sito
              slug
              logo {
                url
                name
              }
              logo_completo {
                url
                name
              }
              logo_sito {
                url
                name
              }
              timbro {
                url
                name
              }
            }
          }
        }
      }
    }
  }
`;
